<template>
    <prime-card class="mx-6 mb-6 max-w-screen-xl lg:mx-12 lg:my-6 xl:mx-auto">
        <template #content>
            <span class="text-xl text-gray-700">Thanks!</span>
            <div class="my-2 text-4xl font-bold text-gray-900">
                Successfully Joined Waitlist
            </div>
            <div
                :style="{
                    height: '3px',
                    background:
                        'linear-gradient(90deg, rgb(var(--color-primary-600)) 0%, rgba(33, 150, 243, 0) 50%)'
                }"
            />

            <content-reset
                v-if="confirmationMessage !== ''"
                :body="confirmationMessage"
                class="mt-8"
            />

            <div class="mt-8">
                <label class="text-2xl font-semibold">Course</label>
                <p class="text-xl">{{ courseDisplayText }}</p>
                <p v-if="courseDatesText !== ''">
                    {{ courseDatesText }}
                </p>
            </div>

            <div class="mt-8">
                <label class="text-2xl font-semibold">Customers</label>
                <div
                    v-for="(customer, index) in customersData"
                    :key="customer.id"
                    :class="index !== 0 ? 'pt-2' : ''"
                >
                    <p class="text-xl">{{ customer.customer.commaName }}</p>
                    <p v-if="customer.notes !== ''">
                        {{ customer.notes }}
                    </p>
                </div>
            </div>

            <div class="mt-16 flex justify-between">
                <nuxt-link :to="facilityHome">
                    <prime-button
                        label="Return to Facility Home"
                        outlined
                        icon="pi pi-fw pi-home"
                        @click="handleBackToHome"
                    />
                </nuxt-link>

                <nuxt-link :to="profileWaitlistsLink()">
                    <prime-button
                        label="View Waitlist Status"
                        icon="pi pi-fw pi-arrow-right"
                    />
                </nuxt-link>
            </div>
        </template>
    </prime-card>
</template>

<script lang="ts">
import { graphql } from '~/resources/graphql'

export const WaitlistConfirmationWaitlistedCustomerFragment =
    graphql(/* GraphQL */ `
        fragment WaitlistConfirmationWaitlistedCustomerFragment on WaitlistedCustomer {
            id
            customer {
                commaName
            }
            notes
        }
    `)
</script>

<script setup lang="ts">
import PrimeButton from 'primevue/button'
import nuxtLink from '#app/components/nuxt-link'
import { computed } from 'vue'
import PrimeCard from 'primevue/card'
import { useRouteLink } from '~/composables/routing'
import { useActiveFacility } from '~/composables/use-active-facility'
import { type FragmentType, getFragmentData } from '~/resources/graphql'
import ContentReset from '~/components/ContentReset.vue'

const props = defineProps<{
    confirmationMessage: string
    courseDisplayText: string
    courseDatesText: string
    customers: [
        FragmentType<typeof WaitlistConfirmationWaitlistedCustomerFragment>
    ]
}>()

const emit = defineEmits<{
    (e: 'backToHome'): void
}>()

const customersData = props.customers.map(customer => {
    return getFragmentData(
        WaitlistConfirmationWaitlistedCustomerFragment,
        customer
    )
})

const { facilityHomeLink, profileWaitlistsLink } = useRouteLink()
const activeFacility = useActiveFacility()
const facilityHome = computed(() => facilityHomeLink(activeFacility.value.slug))

function handleBackToHome() {
    emit('backToHome')
}
</script>
